import styled from 'styled-components';
import { Flex } from '#atoms';
import DaySchedule from './components/DaySchedule';
import React from 'react';

const DAYS = ['월', '화', '수', '목', '금', '토', '일'];

export default function DifferentSchedule() {
  return (
    <>
      <Flex direction="column">
        {DAYS.map((day, index) => {
          return (
            <React.Fragment key={day}>
              <DaySchedule day={day} dayIndex={index} />
              {index !== DAYS.length - 1 && <Divider />}
            </React.Fragment>
          );
        })}
      </Flex>
      <div style={{ height: '56px' }} />
    </>
  );
}

const Divider = styled.div`
  margin: 12px 0px;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.gray700};
`;
